/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable eqeqeq */
import React, { useState } from "react";
import {
  Container,
  Tabs,
  Tab,
  Row,
  Col,
  Spinner,
  Modal,
} from "react-bootstrap";
import useViewBucketList from "./useViewBucketList";
import Header from "../../Common/Header";
import "./ViewBucketList.scss";
import Footer from "../../Common/Footer/Footer";
import { dateFormatter, dateDiff } from "../../../_helpers/dateFormatter";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faXmark } from "@fortawesome/free-solid-svg-icons";
import EmptyFeedCard from "../../../_uiComponents/EmptyFeedCard";
import MainLayout from "../../Common/MainLayout";
import { Link } from "react-router-dom";

export default (props) => {
  const navigate = useNavigate();
  const {
    bucketListData,
    candidatesData,
    assessmentKits,
    assessmentKitsModal,
    loadingBucketList,
    loadingAssessmentKit,
    loadingCandidateList,
    showShareBucketModal,
    shareBucketModalHandler,
    setEmailId,
    formError,
    shareBucketListByEmail,
    loadingShare,
    countTime,
    onViewCandidatesClick,
    countQuestions,
    checkExitingAssessment,
    onViewCandidateProfileClick,
    onClickEditAssessment,
    handleCloseAssessmentModal,
    onClickAddAssementToBucket,
    handleBackClick,
    tabChangesHandler,
    onViewAssessmentClick,
  } = useViewBucketList();

  return (
    <MainLayout pageName={`Bucket - ${bucketListData?.title}`}>
      <Container className="footer-gap">
        <div className="d-flex mb-4 row  justify-content-between align-items-center">
          <div className="d-flex align-items-center col-md-6 mb-3 mb-md-0">
            <button
              className="text-primary border-0 mr-2 bg-transparent"
              onClick={handleBackClick}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            <h2 className="text-capitalize">{bucketListData?.title}</h2>
          </div>

          <div className="d-flex justify-content-center justify-content-md-end col-md-6">
            <button
              className="btn btn-primary mr-3"
              onClick={() => shareBucketModalHandler(true, bucketListData?.id)}
            >
              Share Bucket
            </button>
            <button
              className="btn btn-primary"
              onClick={() => handleCloseAssessmentModal(!assessmentKitsModal)}
            >
              Add Assessment
            </button>
          </div>
        </div>
        <div className="mb-4 hiring-process-dashboard kanban-board-main">
          <Tabs
            defaultActiveKey="AssignedAssessmentKits"
            onSelect={() => tabChangesHandler()}
          >
            <Tab
              eventKey="AssignedAssessmentKits"
              title="Assigned Assessment Kits"
            >
              <div className="row">
                {loadingBucketList ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <>
                    {Array.isArray(
                      bucketListData?.assigned_assessments_details
                    ) && bucketListData.assigned_assessments_details.length ? (
                      <>
                        {Array.isArray(
                          bucketListData?.assigned_assessments_details
                        ) &&
                          bucketListData.assigned_assessments_details.map(
                            (item) => (
                              <div className="col-lg-6 mb-4" key={item?.id}>
                                <div className="p-4 bg-white border position-relative h-100 rounded-lg">
                                  <div className="upper">
                                    <div className="d-flex mb-1">
                                      <h3 className="font-weight-medium mb-1 text-capitalize text-primary mr-2">
                                        {item?.title}
                                      </h3>
                                      <div className="d-flex ml-auto">
                                        <button
                                          className="bg-transparent border-0 py-0 text-dark"
                                          title="Edit"
                                          onClick={() =>
                                            onClickEditAssessment(item?.id)
                                          }
                                        >
                                          <img
                                            src="/assets/images/edit-grey.svg"
                                            alt="edit"
                                          />
                                        </button>
                                      </div>
                                    </div>

                                    <div className="mb-2">
                                      <span className="mt-2 mr-4 font-weight-medium">
                                        <span className="text-grey-4 font-weight-normal">
                                          {" "}
                                          Total Topics :{" "}
                                        </span>
                                        {(Array.isArray(item && item?.topics) &&
                                          item &&
                                          item?.topics &&
                                          item?.topics.length) ||
                                          0}{" "}
                                      </span>
                                      <span className="mt-2 mr-4 font-weight-medium">
                                        <span className="text-grey-4 font-weight-normal">
                                          {" "}
                                          Total Questions :{" "}
                                        </span>

                                        {countQuestions(item?.topics)}
                                      </span>
                                      <span className="mt-2 mr-4 font-weight-medium">
                                        <span className="text-grey-4 font-weight-normal">
                                          {" "}
                                          Candidates Assigned :{" "}
                                        </span>
                                        {item?.assigned_candidates_count}
                                      </span>
                                      <span className="mt-2 mr-4 font-weight-medium">
                                        <span className="text-grey-4 font-weight-normal">
                                          {" "}
                                          Candidates Accepted :{" "}
                                        </span>
                                        {item?.accepted_interview_kits_count}
                                      </span>
                                      <span className="mt-2 mr-4 font-weight-medium">
                                        <span className="text-grey-4 font-weight-normal">
                                          {" "}
                                          Candidates Accepted :{" "}
                                        </span>
                                        {item?.accepted_interview_kits_count}
                                      </span>
                                    </div>
                                  </div>
                                  {item?.all_skills &&
                                  Array.isArray(item?.all_skills) &&
                                  item?.all_skills.length > 0 ? (
                                    <div className="d-flex align-items-center flex-wrap fs-smallest mb-2 mt-3">
                                      <p className="mb-0 mr-2 text-capitalize">
                                        {Array.isArray(
                                          item?.all_skills && item?.all_skills
                                        ) &&
                                          item?.all_skills &&
                                          item?.all_skills.map(
                                            (skill, index) => (
                                              <span
                                                key={index}
                                                className="skill bg-grey px-2 rounded-sm mr-2 my-1 py-1 mb-2"
                                              >
                                                {skill?.skill}
                                              </span>
                                            )
                                          )}
                                      </p>
                                    </div>
                                  ) : null}
                                  <div className="d-flex justify-content-between align-items-center mt-3 flex-md-wrap flex-lg-nowrap">
                                    <p className="mb-0 mr-2 font-weight-medium text-grey-4 fs-smallest">
                                      {dateDiff(item?.created, new Date())} ago
                                    </p>
                                    <div className="job-bottom d-flex align-items-center justify-content-between mt-0 mt-md-3 mt-lg-0">
                                      <button
                                        className="text-primary border-0 bg-transparent font-weight-semi text-nowrap"
                                        onClick={() =>
                                          onViewCandidatesClick(item?.id)
                                        }
                                      >
                                        View Candidates
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                      </>
                    ) : (
                      <div
                        className="d-flex align-items-center col-12
                        justify-content-center flex-column py-4"
                      >
                        <img src="/assets/images/empty-state.svg" alt="empty" />
                        <h4 className="font-weight-bold mb-1 mt-2">
                          No Assessment is added to this bucket list!
                        </h4>
                        <p className="mb-4 fs-smallest">
                          Start Creating Bucket List
                        </p>
                        <button
                          onClick={() =>
                            handleCloseAssessmentModal(!assessmentKitsModal)
                          }
                          className="px-4 border border-primary shadow
                          text-primary py-1 rounded-lg font-weight-semi"
                        >
                          See Bucket list
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Tab>
            <Tab eventKey="Candidates" title="Candidates">
              <div className="row ">
                {loadingCandidateList ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <>
                    {Array.isArray(candidatesData) && candidatesData.length ? (
                      <>
                        {Array.isArray(candidatesData) &&
                          candidatesData.map((item) => (
                            <div className="col-lg-4 col-md-6 mb-4 ">
                              <div className="bg-white border position-relative h-100 rounded-lg p-3">
                                <div className="d-flex w-100 mb-3">
                                  <img
                                    src={
                                      item?.candidate_details?.user_meta_info
                                        ?.profile_image
                                        ? item?.candidate_details
                                            ?.user_meta_info?.profile_image
                                        : "/assets/images/user.png"
                                    }
                                    alt="candidate"
                                    className="mr-3 border-radius-10"
                                    style={{
                                      height: "40px",
                                      width: "40px",
                                      objectFit: "cover",
                                      objectPosition: "center",
                                    }}
                                  />
                                  <div className="title">
                                    <h3
                                      className="font-weight-medium mb-0 text-capitalize text-primary"
                                      onClick={() =>
                                        onViewCandidateProfileClick(
                                          item?.candidate_details &&
                                            item.candidate_details?.hash_id
                                        )
                                      }
                                    >
                                      {item?.candidate_details &&
                                        item?.candidate_details?.full_name}
                                    </h3>
                                    <p className="mb-0 text-grey-4 fs-smallest">
                                      {item?.candidate_details &&
                                        item?.candidate_details?.headline}
                                    </p>
                                  </div>
                                </div>

                                <h4>Assessments</h4>
                                <ul className="d-flex flex-wrap">
                                  {item?.all_interviews_assigned &&
                                    Array.isArray(
                                      item?.all_interviews_assigned
                                    ) &&
                                    item.all_interviews_assigned.map(
                                      (assessment) => (
                                        <li className="flex-wrap d-flex bg-grey fs-smallest py-1 px-2 rounded-sm mr-2 my-1">
                                          {" "}
                                          <p
                                            className="skill text-dark text-capitalize cursor-pointer font-weight-semi mb-0"
                                            onClick={() =>
                                              onViewAssessmentClick(
                                                assessment?.id,
                                                item?.candidate
                                              )
                                            }
                                          >
                                            {assessment?.title} :
                                          </p>
                                          <div className="text-right">
                                            <span
                                              className={`d-inline-block ${
                                                assessment?.remaining_questions_count ===
                                                0
                                                  ? "label-blue"
                                                  : assessment?.assessment_kit_accepted ===
                                                    true
                                                  ? "label-voilet"
                                                  : "label-yellow"
                                              } rounded position px-2 ml-2`}
                                            >
                                              {assessment?.remaining_questions_count ===
                                              0
                                                ? "Completed"
                                                : assessment?.assessment_kit_accepted
                                                ? "Accepted"
                                                : "Pending"}
                                            </span>
                                          </div>
                                        </li>
                                      )
                                    )}
                                </ul>
                                <p className="mb-3 text-capitalize font-weight-medium mr-2 d-flex align-items-center">
                                  {item?.all_interviews_assigned &&
                                  Array.isArray(item.all_interviews_assigned) &&
                                  item.all_interviews_assigned.length ? (
                                    <div className="skills-list"></div>
                                  ) : (
                                    "Not Available"
                                  )}
                                </p>

                                {item?.candidate_details &&
                                item?.candidate_details?.skills &&
                                Array.isArray(
                                  item?.candidate_details?.skills
                                ) &&
                                item?.candidate_details?.skills.length > 0 ? (
                                  <div className="d-flex align-items-center flex-wrap fs-smallest mb-3">
                                    <p className="mb-0 mr-2 text-capitalize">
                                      <span className="font-weight-medium">
                                        Skills:{" "}
                                      </span>
                                      {Array.isArray(
                                        item?.candidate_details &&
                                          item?.candidate_details?.skills &&
                                          item?.candidate_details?.skills
                                      ) &&
                                        item?.candidate_details &&
                                        item?.candidate_details?.skills &&
                                        item?.candidate_details?.skills.map(
                                          (skill, index) => (
                                            <span
                                              key={index}
                                              className="skill bg-grey px-2 rounded-sm mr-2 my-1 py-1 mb-2"
                                            >
                                              {skill}
                                            </span>
                                          )
                                        )}
                                    </p>
                                  </div>
                                ) : null}

                                <div className=" text-right">
                                  <button
                                    className="border-0 fs-smallest text-primary font-weight-bold bg-transparent "
                                    onClick={() =>
                                      onViewCandidateProfileClick(
                                        item?.candidate_details &&
                                          item.candidate_details?.hash_id
                                      )
                                    }
                                  >
                                    View Candidate
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                      </>
                    ) : (
                      <div
                        className="d-flex align-items-center col-12
                      justify-content-center flex-column py-4"
                      >
                        <img src="/assets/images/empty-state.svg" alt="empty" />
                        <h4 className="font-weight-bold mb-1 mt-2">
                          No Candidate found in bucket list!
                        </h4>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Tab>
          </Tabs>
        </div>
      </Container>

      <Modal
        size="md"
        show={assessmentKitsModal}
        onHide={() => handleCloseAssessmentModal(!assessmentKitsModal)}
        className=""
      >
        <Modal.Header className="bg-primary text-white">
          <Modal.Title className="text-uppercase">
            <h3 className="mb-0 text-white">Select Assessment Kit</h3>
          </Modal.Title>

          <FontAwesomeIcon
            icon={faXmark}
            className="fa-2x cursor-pointer"
            onClick={() => handleCloseAssessmentModal(!assessmentKitsModal)}
          />
        </Modal.Header>

        <Modal.Body className="p-4">
          {loadingAssessmentKit ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <>
              {Array.isArray(assessmentKits) &&
                assessmentKits.map((item) => (
                  <div className="d-flex mb-3 justify-content-between">
                    <span className="text-capitalize">{item?.title}</span>

                    <button
                      className="btn btn-primary"
                      disabled={checkExitingAssessment(item?.id)}
                      onClick={() => onClickAddAssementToBucket(item?.id)}
                    >
                      {checkExitingAssessment(item?.id) ? "Assigned" : "Assign"}
                    </button>
                  </div>
                ))}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={showShareBucketModal}
        onHide={() => shareBucketModalHandler(false)}
        className="border-0 common-modal apply-job-modal"
        centered
      >
        <Modal.Header className="bg-primary text-white">
          <Modal.Title className="text-uppercase">
            <h3 className="mb-0 text-white">Share Bucket</h3>
          </Modal.Title>
          <FontAwesomeIcon
            icon={faXmark}
            className="fa-2x cursor-pointer"
            onClick={() => shareBucketModalHandler(false)}
          />
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="form-group mb-0 py-3">
            <p className="font-weight-medium">
              <span className="text-danger">* </span>Enter Email Id
            </p>
            <div className="form-group">
              <input
                className="form-control"
                type="text"
                placeholder="Enter Hiring Manager's Email Id"
                name="title"
                onBlur={(e) => setEmailId(e.target.value)}
              />
              {formError?.emailId ? (
                <p className="text-danger mt-2">{formError?.emailId} </p>
              ) : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center justify-content-end">
            <button
              className="btn btn-primary ml-4"
              onClick={() => shareBucketListByEmail()}
            >
              {loadingShare ? (
                <Spinner animation="border" variant="light" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </MainLayout>
  );
};
